<div class="title-container">
  <h3 class="title">
    {{ 'Reports.PortfolioReport.DebtorsAges' | translate }}
  </h3>
  <hr class="separation-line" />
</div>

<div class="canvas" id="canvas">
  <canvas [id]="canvasId"></canvas>
</div>

<div id="noData">
  {{'Reports.PortfolioReport.NoData' | translate}}
</div>
